import React from "react";
import { Col, Container, Row } from "react-bootstrap";
//import AboutAndSustainabilityContentForm from "./AboutAndSustainabilityContentForm";
import PartnershipContentForm from "./PartnershipContentForm";
import { useGetAboutAndSustainabilityContentDetailsQuery } from "../../../../store/services/AboutAndSustainabilityContentService";
import { useGetPartnershipContentDetailsQuery } from "../../../../store/services/PartnershipContentService";

function PartnershipContent() {
  const { data: pageDetails, error, isLoading } = useGetPartnershipContentDetailsQuery();

  console.log("details =======>", pageDetails?.data);

  return (
    <section className="setting position-relative py-3">
      <Container>
        <Row className="justify-content-center">
          <Col lg="12">
            <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
              Partnership & Affiliates Content
            </h4>
          </Col>

          {isLoading && (
            <div className="text-center">
              <div className="spinner-border text-dark">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          )}
          {!isLoading && (
            <PartnershipContentForm data={pageDetails?.data} />
          )}
        </Row>
      </Container>
    </section>
  );
}

export default PartnershipContent;
